import All from "./OnBoardingBody";

const OnBoarding = () => {

  return (
   <All/>
  );
};

export default OnBoarding;